import { useMutation } from '@debbie/common/dist/util/hooks.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import NewEditor from './editor/Editor.js';
import { useEditorState } from './editor/hooks.js';
import Edit from './Icons/Edit.js';
import { Button, Modal, Well } from './index.js';
const RichTextField = (props) => {
    const lang = useSelector((s) => s.lang);
    const contentState = useEditorState(props.value ?? '');
    const [editModalOpen, setEditModalOpen] = useState(false);
    useEffect(() => {
        if (props.value) {
            contentState.overwriteEditorContent(props.value);
        }
    }, [props.value]);
    const updateMutation = useMutation(() => props.onUpdate(contentState.html), {
        onSuccess: () => {
            setEditModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', props.header);
        },
    });
    const update = () => {
        updateMutation.mutate();
    };
    return (React.createElement("div", { style: {
            position: 'relative',
        } },
        props.value ? (React.createElement(Well, { style: { ...style, ...props.style }, dangerouslySetInnerHTML: {
                __html: props.value,
            } })) : (React.createElement(Well, { style: { ...style, ...props.style } },
            React.createElement("p", { style: {
                    opacity: '0.7',
                    fontWeight: 900,
                    margin: '0.3em 0',
                } }, lang.creditors.mandatesPlaceholder))),
        props.canUpdate && (React.createElement(Edit, { style: {
                top: '10px',
                right: '10px',
                position: 'absolute',
                cursor: 'pointer',
            }, onClick: () => setEditModalOpen(!editModalOpen) })),
        editModalOpen && (React.createElement(Modal, { onToggle: () => setEditModalOpen(!editModalOpen), header: props.header },
            React.createElement(NewEditor, { mentions: [], onChange: contentState.onChange, initialContent: contentState.editorContent }),
            React.createElement("br", null),
            React.createElement(Button, { loading: updateMutation.isLoading, onClick: update, block: true }, lang.misc.save)))));
};
const style = {
    fontSize: '.7em',
    padding: `10px ${THEME.GRID_SPACING}px`,
    minHeight: '40px',
    marginBottom: `${THEME.GRID_SPACING}px`,
};
export default RichTextField;
//# sourceMappingURL=RichTextField.js.map